import html2canvas from 'html2canvas';

// Función auxiliar para descargar una imagen
const downloadImage = (dataUrl, filename) => {
    const link = document.createElement('a');
    link.href = dataUrl;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};

export const generarImagenes = async (html, nombreBase = 'Comprobante_Venta', numeroDocumento) => {
    // 1. Configurar contenedor temporal para la captura, aislado contra temas oscuros
    const tempContainer = document.createElement('div');
    tempContainer.className = 'isolated-print-theme ticket-impresion-container';
    tempContainer.style.position = 'fixed';
    tempContainer.style.left = '-99999px';
    tempContainer.style.top = '0';
    tempContainer.style.width = '300px'; // Un ancho fijo para la captura
    tempContainer.style.backgroundColor = '#ffffff';
    tempContainer.style.color = '#000000';
    tempContainer.style.zIndex = '-9999';

    // Inyectar reset estricto de estilos para garantizar texto 100% negro y legible en html2canvas sin importar el tema de la aplicación
    const resetStyles = `
    <style>
      .isolated-print-theme,
      .isolated-print-theme * {
          color: #000000 !important;
          -webkit-text-fill-color: #000000 !important;
          background-color: transparent;
          box-sizing: border-box;
      }
      .isolated-print-theme strong,
      .isolated-print-theme b,
      .isolated-print-theme .font-weight-bold {
          color: #000000 !important;
          -webkit-text-fill-color: #000000 !important;
          font-weight: bold !important;
      }
    </style>
    `;

    tempContainer.innerHTML = resetStyles + html;
    document.body.appendChild(tempContainer);

    try {
        const nombreArchivo = `${nombreBase}_${numeroDocumento}`;

        // 2. Generar Canvas con fondo blanco forzado
        const canvas = await html2canvas(tempContainer, {
            scale: 2, // Mayor escala para mejor calidad de imagen
            useCORS: true,
            backgroundColor: '#ffffff'
        });

        // 4. Generar y Descargar JPEG (se usa el mismo canvas)
        const jpegData = canvas.toDataURL('image/jpeg', 1.0);
        downloadImage(jpegData, `${nombreArchivo}.jpeg`);

    } catch (error) {
        console.error("Error al generar Imágenes:", error);
    } finally {
        // 5. Limpieza
        if (document.body.contains(tempContainer)) {
            document.body.removeChild(tempContainer);
        }
    }
};
